export enum StorageKey {
  NOTIFICATION_LAUNCHES = "notification_launches",
  NOTIFICATION_PROMPT_DATE = "notification_prompt_date",
  STOP_ASKING_FOR_NOTIFICATIONS = "stop_asking_for_notifications",
}
